/**
 * Fecha de hoy (YYYY-MM-DD) en la hora local del navegador (RD).
 *
 * `new Date().toISOString()` da la fecha en UTC: desde las 8:00 p.m. en RD ya
 * es el día siguiente, y la factura, el asiento contable y el QR del e-CF
 * quedaban con fechas distintas.
 */
export const hoyLocal = (d = new Date()) =>
  `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
